function subscribe(eventName, listener) {
  document.addEventListener(eventName, listener);
}

export {subscribe};